const FETCH_STORIES = 'tagDetail/FETCH_STORIES';

const RESET = 'tagDetail/RESET';

const SET_TAG_ID = 'tagDetail/SET_TAG_ID';

export default {
  FETCH_STORIES,
  RESET,
  SET_TAG_ID,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/tagDetail/types.js